import { toast } from 'react-toastify';
import { logout } from '../store/authSlice';
import axiosInstance from './axios';

/**
 * Method to handle errors.
 */
const responseErrorHandler = (store: any, error: any) => {    
    const { response } = error;
    if (response) {
        toast.error(response.data.message || response.data);

        // If user is not authenticated then redirect the user to login page. 
        if (response?.status === 401) {
            store.dispatch(logout());
        }
    } else {
        toast.error(error.message);
    }

    return Promise.reject(error);
}

/**
 * Method to add api response interceptor and handle errors.
 */
const setupApiResponseInterceptors = (store: any) => {
    // Add a response interceptor to handle errors at one place.
    axiosInstance.interceptors.response.use(
        (response) => response,
        (error) => responseErrorHandler(store, error),
    );
}

export default setupApiResponseInterceptors;
